// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/common/countries.proto (package squareup.common.countries, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file squareup/common/countries.proto.
 */
export const file_squareup_common_countries: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * *
 * ISO-3166-1 Country Codes
 * http://www.iso.org/iso/home/standards/country_codes.htm
 * Names are the alpha-2 code, ordinals are the numerics
 *
 * @generated from enum squareup.common.countries.Country
 */
export enum Country {
  /**
   * listed first to be a suitable default
   *
   * @generated from enum value: US = 840;
   */
  US = 840,

  /**
   * @generated from enum value: AD = 20;
   */
  AD = 20,

  /**
   * @generated from enum value: AE = 784;
   */
  AE = 784,

  /**
   * @generated from enum value: AF = 4;
   */
  AF = 4,

  /**
   * @generated from enum value: AG = 28;
   */
  AG = 28,

  /**
   * @generated from enum value: AI = 660;
   */
  AI = 660,

  /**
   * @generated from enum value: AL = 8;
   */
  AL = 8,

  /**
   * @generated from enum value: AM = 51;
   */
  AM = 51,

  /**
   * @generated from enum value: AO = 24;
   */
  AO = 24,

  /**
   * @generated from enum value: AQ = 10;
   */
  AQ = 10,

  /**
   * @generated from enum value: AR = 32;
   */
  AR = 32,

  /**
   * @generated from enum value: AS = 16;
   */
  AS = 16,

  /**
   * @generated from enum value: AT = 40;
   */
  AT = 40,

  /**
   * @generated from enum value: AU = 36;
   */
  AU = 36,

  /**
   * @generated from enum value: AW = 533;
   */
  AW = 533,

  /**
   * @generated from enum value: AX = 248;
   */
  AX = 248,

  /**
   * @generated from enum value: AZ = 31;
   */
  AZ = 31,

  /**
   * @generated from enum value: BA = 70;
   */
  BA = 70,

  /**
   * @generated from enum value: BB = 52;
   */
  BB = 52,

  /**
   * @generated from enum value: BD = 50;
   */
  BD = 50,

  /**
   * @generated from enum value: BE = 56;
   */
  BE = 56,

  /**
   * @generated from enum value: BF = 854;
   */
  BF = 854,

  /**
   * @generated from enum value: BG = 100;
   */
  BG = 100,

  /**
   * @generated from enum value: BH = 48;
   */
  BH = 48,

  /**
   * @generated from enum value: BI = 108;
   */
  BI = 108,

  /**
   * @generated from enum value: BJ = 204;
   */
  BJ = 204,

  /**
   * @generated from enum value: BL = 652;
   */
  BL = 652,

  /**
   * @generated from enum value: BM = 60;
   */
  BM = 60,

  /**
   * @generated from enum value: BN = 96;
   */
  BN = 96,

  /**
   * @generated from enum value: BO = 68;
   */
  BO = 68,

  /**
   * @generated from enum value: BQ = 535;
   */
  BQ = 535,

  /**
   * @generated from enum value: BR = 76;
   */
  BR = 76,

  /**
   * @generated from enum value: BS = 44;
   */
  BS = 44,

  /**
   * @generated from enum value: BT = 64;
   */
  BT = 64,

  /**
   * @generated from enum value: BV = 74;
   */
  BV = 74,

  /**
   * @generated from enum value: BW = 72;
   */
  BW = 72,

  /**
   * @generated from enum value: BY = 112;
   */
  BY = 112,

  /**
   * @generated from enum value: BZ = 84;
   */
  BZ = 84,

  /**
   * @generated from enum value: CA = 124;
   */
  CA = 124,

  /**
   * @generated from enum value: CC = 166;
   */
  CC = 166,

  /**
   * @generated from enum value: CD = 180;
   */
  CD = 180,

  /**
   * @generated from enum value: CF = 140;
   */
  CF = 140,

  /**
   * @generated from enum value: CG = 178;
   */
  CG = 178,

  /**
   * @generated from enum value: CH = 756;
   */
  CH = 756,

  /**
   * @generated from enum value: CI = 384;
   */
  CI = 384,

  /**
   * @generated from enum value: CK = 184;
   */
  CK = 184,

  /**
   * @generated from enum value: CL = 152;
   */
  CL = 152,

  /**
   * @generated from enum value: CM = 120;
   */
  CM = 120,

  /**
   * @generated from enum value: CN = 156;
   */
  CN = 156,

  /**
   * @generated from enum value: CO = 170;
   */
  CO = 170,

  /**
   * @generated from enum value: CR = 188;
   */
  CR = 188,

  /**
   * @generated from enum value: CU = 192;
   */
  CU = 192,

  /**
   * @generated from enum value: CV = 132;
   */
  CV = 132,

  /**
   * @generated from enum value: CW = 531;
   */
  CW = 531,

  /**
   * @generated from enum value: CX = 162;
   */
  CX = 162,

  /**
   * @generated from enum value: CY = 196;
   */
  CY = 196,

  /**
   * @generated from enum value: CZ = 203;
   */
  CZ = 203,

  /**
   * @generated from enum value: DE = 276;
   */
  DE = 276,

  /**
   * @generated from enum value: DJ = 262;
   */
  DJ = 262,

  /**
   * @generated from enum value: DK = 208;
   */
  DK = 208,

  /**
   * @generated from enum value: DM = 212;
   */
  DM = 212,

  /**
   * @generated from enum value: DO = 214;
   */
  DO = 214,

  /**
   * @generated from enum value: DZ = 12;
   */
  DZ = 12,

  /**
   * @generated from enum value: EC = 218;
   */
  EC = 218,

  /**
   * @generated from enum value: EE = 233;
   */
  EE = 233,

  /**
   * @generated from enum value: EG = 818;
   */
  EG = 818,

  /**
   * @generated from enum value: EH = 732;
   */
  EH = 732,

  /**
   * @generated from enum value: ER = 232;
   */
  ER = 232,

  /**
   * @generated from enum value: ES = 724;
   */
  ES = 724,

  /**
   * @generated from enum value: ET = 231;
   */
  ET = 231,

  /**
   * @generated from enum value: FI = 246;
   */
  FI = 246,

  /**
   * @generated from enum value: FJ = 242;
   */
  FJ = 242,

  /**
   * @generated from enum value: FK = 238;
   */
  FK = 238,

  /**
   * @generated from enum value: FM = 583;
   */
  FM = 583,

  /**
   * @generated from enum value: FO = 234;
   */
  FO = 234,

  /**
   * @generated from enum value: FR = 250;
   */
  FR = 250,

  /**
   * @generated from enum value: GA = 266;
   */
  GA = 266,

  /**
   * @generated from enum value: GB = 826;
   */
  GB = 826,

  /**
   * @generated from enum value: GD = 308;
   */
  GD = 308,

  /**
   * @generated from enum value: GE = 268;
   */
  GE = 268,

  /**
   * @generated from enum value: GF = 254;
   */
  GF = 254,

  /**
   * @generated from enum value: GG = 831;
   */
  GG = 831,

  /**
   * @generated from enum value: GH = 288;
   */
  GH = 288,

  /**
   * @generated from enum value: GI = 292;
   */
  GI = 292,

  /**
   * @generated from enum value: GL = 304;
   */
  GL = 304,

  /**
   * @generated from enum value: GM = 270;
   */
  GM = 270,

  /**
   * @generated from enum value: GN = 324;
   */
  GN = 324,

  /**
   * @generated from enum value: GP = 312;
   */
  GP = 312,

  /**
   * @generated from enum value: GQ = 226;
   */
  GQ = 226,

  /**
   * @generated from enum value: GR = 300;
   */
  GR = 300,

  /**
   * @generated from enum value: GS = 239;
   */
  GS = 239,

  /**
   * @generated from enum value: GT = 320;
   */
  GT = 320,

  /**
   * @generated from enum value: GU = 316;
   */
  GU = 316,

  /**
   * @generated from enum value: GW = 624;
   */
  GW = 624,

  /**
   * @generated from enum value: GY = 328;
   */
  GY = 328,

  /**
   * @generated from enum value: HK = 344;
   */
  HK = 344,

  /**
   * @generated from enum value: HM = 334;
   */
  HM = 334,

  /**
   * @generated from enum value: HN = 340;
   */
  HN = 340,

  /**
   * @generated from enum value: HR = 191;
   */
  HR = 191,

  /**
   * @generated from enum value: HT = 332;
   */
  HT = 332,

  /**
   * @generated from enum value: HU = 348;
   */
  HU = 348,

  /**
   * @generated from enum value: ID = 360;
   */
  ID = 360,

  /**
   * @generated from enum value: IE = 372;
   */
  IE = 372,

  /**
   * @generated from enum value: IL = 376;
   */
  IL = 376,

  /**
   * @generated from enum value: IM = 833;
   */
  IM = 833,

  /**
   * @generated from enum value: IN = 356;
   */
  IN = 356,

  /**
   * @generated from enum value: IO = 86;
   */
  IO = 86,

  /**
   * @generated from enum value: IQ = 368;
   */
  IQ = 368,

  /**
   * @generated from enum value: IR = 364;
   */
  IR = 364,

  /**
   * @generated from enum value: IS = 352;
   */
  IS = 352,

  /**
   * @generated from enum value: IT = 380;
   */
  IT = 380,

  /**
   * @generated from enum value: JE = 832;
   */
  JE = 832,

  /**
   * @generated from enum value: JM = 388;
   */
  JM = 388,

  /**
   * @generated from enum value: JO = 400;
   */
  JO = 400,

  /**
   * @generated from enum value: JP = 392;
   */
  JP = 392,

  /**
   * @generated from enum value: KE = 404;
   */
  KE = 404,

  /**
   * @generated from enum value: KG = 417;
   */
  KG = 417,

  /**
   * @generated from enum value: KH = 116;
   */
  KH = 116,

  /**
   * @generated from enum value: KI = 296;
   */
  KI = 296,

  /**
   * @generated from enum value: KM = 174;
   */
  KM = 174,

  /**
   * @generated from enum value: KN = 659;
   */
  KN = 659,

  /**
   * @generated from enum value: KP = 408;
   */
  KP = 408,

  /**
   * @generated from enum value: KR = 410;
   */
  KR = 410,

  /**
   * @generated from enum value: KW = 414;
   */
  KW = 414,

  /**
   * @generated from enum value: KY = 136;
   */
  KY = 136,

  /**
   * @generated from enum value: KZ = 398;
   */
  KZ = 398,

  /**
   * @generated from enum value: LA = 418;
   */
  LA = 418,

  /**
   * @generated from enum value: LB = 422;
   */
  LB = 422,

  /**
   * @generated from enum value: LC = 662;
   */
  LC = 662,

  /**
   * @generated from enum value: LI = 438;
   */
  LI = 438,

  /**
   * @generated from enum value: LK = 144;
   */
  LK = 144,

  /**
   * @generated from enum value: LR = 430;
   */
  LR = 430,

  /**
   * @generated from enum value: LS = 426;
   */
  LS = 426,

  /**
   * @generated from enum value: LT = 440;
   */
  LT = 440,

  /**
   * @generated from enum value: LU = 442;
   */
  LU = 442,

  /**
   * @generated from enum value: LV = 428;
   */
  LV = 428,

  /**
   * @generated from enum value: LY = 434;
   */
  LY = 434,

  /**
   * @generated from enum value: MA = 504;
   */
  MA = 504,

  /**
   * @generated from enum value: MC = 492;
   */
  MC = 492,

  /**
   * @generated from enum value: MD = 498;
   */
  MD = 498,

  /**
   * @generated from enum value: ME = 499;
   */
  ME = 499,

  /**
   * @generated from enum value: MF = 663;
   */
  MF = 663,

  /**
   * @generated from enum value: MG = 450;
   */
  MG = 450,

  /**
   * @generated from enum value: MH = 584;
   */
  MH = 584,

  /**
   * @generated from enum value: MK = 807;
   */
  MK = 807,

  /**
   * @generated from enum value: ML = 466;
   */
  ML = 466,

  /**
   * @generated from enum value: MM = 104;
   */
  MM = 104,

  /**
   * @generated from enum value: MN = 496;
   */
  MN = 496,

  /**
   * @generated from enum value: MO = 446;
   */
  MO = 446,

  /**
   * @generated from enum value: MP = 580;
   */
  MP = 580,

  /**
   * @generated from enum value: MQ = 474;
   */
  MQ = 474,

  /**
   * @generated from enum value: MR = 478;
   */
  MR = 478,

  /**
   * @generated from enum value: MS = 500;
   */
  MS = 500,

  /**
   * @generated from enum value: MT = 470;
   */
  MT = 470,

  /**
   * @generated from enum value: MU = 480;
   */
  MU = 480,

  /**
   * @generated from enum value: MV = 462;
   */
  MV = 462,

  /**
   * @generated from enum value: MW = 454;
   */
  MW = 454,

  /**
   * @generated from enum value: MX = 484;
   */
  MX = 484,

  /**
   * @generated from enum value: MY = 458;
   */
  MY = 458,

  /**
   * @generated from enum value: MZ = 508;
   */
  MZ = 508,

  /**
   * @generated from enum value: NA = 516;
   */
  NA = 516,

  /**
   * @generated from enum value: NC = 540;
   */
  NC = 540,

  /**
   * @generated from enum value: NE = 562;
   */
  NE = 562,

  /**
   * @generated from enum value: NF = 574;
   */
  NF = 574,

  /**
   * @generated from enum value: NG = 566;
   */
  NG = 566,

  /**
   * @generated from enum value: NI = 558;
   */
  NI = 558,

  /**
   * @generated from enum value: NL = 528;
   */
  NL = 528,

  /**
   * @generated from enum value: NO = 578;
   */
  NO = 578,

  /**
   * @generated from enum value: NP = 524;
   */
  NP = 524,

  /**
   * @generated from enum value: NR = 520;
   */
  NR = 520,

  /**
   * @generated from enum value: NU = 570;
   */
  NU = 570,

  /**
   * @generated from enum value: NZ = 554;
   */
  NZ = 554,

  /**
   * @generated from enum value: OM = 512;
   */
  OM = 512,

  /**
   * @generated from enum value: PA = 591;
   */
  PA = 591,

  /**
   * @generated from enum value: PE = 604;
   */
  PE = 604,

  /**
   * @generated from enum value: PF = 258;
   */
  PF = 258,

  /**
   * @generated from enum value: PG = 598;
   */
  PG = 598,

  /**
   * @generated from enum value: PH = 608;
   */
  PH = 608,

  /**
   * @generated from enum value: PK = 586;
   */
  PK = 586,

  /**
   * @generated from enum value: PL = 616;
   */
  PL = 616,

  /**
   * @generated from enum value: PM = 666;
   */
  PM = 666,

  /**
   * @generated from enum value: PN = 612;
   */
  PN = 612,

  /**
   * @generated from enum value: PR = 630;
   */
  PR = 630,

  /**
   * @generated from enum value: PS = 275;
   */
  PS = 275,

  /**
   * @generated from enum value: PT = 620;
   */
  PT = 620,

  /**
   * @generated from enum value: PW = 585;
   */
  PW = 585,

  /**
   * @generated from enum value: PY = 600;
   */
  PY = 600,

  /**
   * @generated from enum value: QA = 634;
   */
  QA = 634,

  /**
   * @generated from enum value: RE = 638;
   */
  RE = 638,

  /**
   * @generated from enum value: RO = 642;
   */
  RO = 642,

  /**
   * @generated from enum value: RS = 688;
   */
  RS = 688,

  /**
   * @generated from enum value: RU = 643;
   */
  RU = 643,

  /**
   * @generated from enum value: RW = 646;
   */
  RW = 646,

  /**
   * @generated from enum value: SA = 682;
   */
  SA = 682,

  /**
   * @generated from enum value: SB = 90;
   */
  SB = 90,

  /**
   * @generated from enum value: SC = 690;
   */
  SC = 690,

  /**
   * @generated from enum value: SD = 729;
   */
  SD = 729,

  /**
   * @generated from enum value: SE = 752;
   */
  SE = 752,

  /**
   * @generated from enum value: SG = 702;
   */
  SG = 702,

  /**
   * @generated from enum value: SH = 654;
   */
  SH = 654,

  /**
   * @generated from enum value: SI = 705;
   */
  SI = 705,

  /**
   * @generated from enum value: SJ = 744;
   */
  SJ = 744,

  /**
   * @generated from enum value: SK = 703;
   */
  SK = 703,

  /**
   * @generated from enum value: SL = 694;
   */
  SL = 694,

  /**
   * @generated from enum value: SM = 674;
   */
  SM = 674,

  /**
   * @generated from enum value: SN = 686;
   */
  SN = 686,

  /**
   * @generated from enum value: SO = 706;
   */
  SO = 706,

  /**
   * @generated from enum value: SR = 740;
   */
  SR = 740,

  /**
   * @generated from enum value: SS = 728;
   */
  SS = 728,

  /**
   * @generated from enum value: ST = 678;
   */
  ST = 678,

  /**
   * @generated from enum value: SV = 222;
   */
  SV = 222,

  /**
   * @generated from enum value: SX = 534;
   */
  SX = 534,

  /**
   * @generated from enum value: SY = 760;
   */
  SY = 760,

  /**
   * @generated from enum value: SZ = 748;
   */
  SZ = 748,

  /**
   * @generated from enum value: TC = 796;
   */
  TC = 796,

  /**
   * @generated from enum value: TD = 148;
   */
  TD = 148,

  /**
   * @generated from enum value: TF = 260;
   */
  TF = 260,

  /**
   * @generated from enum value: TG = 768;
   */
  TG = 768,

  /**
   * @generated from enum value: TH = 764;
   */
  TH = 764,

  /**
   * @generated from enum value: TJ = 762;
   */
  TJ = 762,

  /**
   * @generated from enum value: TK = 772;
   */
  TK = 772,

  /**
   * @generated from enum value: TL = 626;
   */
  TL = 626,

  /**
   * @generated from enum value: TM = 795;
   */
  TM = 795,

  /**
   * @generated from enum value: TN = 788;
   */
  TN = 788,

  /**
   * @generated from enum value: TO = 776;
   */
  TO = 776,

  /**
   * @generated from enum value: TR = 792;
   */
  TR = 792,

  /**
   * @generated from enum value: TT = 780;
   */
  TT = 780,

  /**
   * @generated from enum value: TV = 798;
   */
  TV = 798,

  /**
   * @generated from enum value: TW = 158;
   */
  TW = 158,

  /**
   * @generated from enum value: TZ = 834;
   */
  TZ = 834,

  /**
   * @generated from enum value: UA = 804;
   */
  UA = 804,

  /**
   * @generated from enum value: UG = 800;
   */
  UG = 800,

  /**
   * @generated from enum value: UM = 581;
   */
  UM = 581,

  /**
   * @generated from enum value: UY = 858;
   */
  UY = 858,

  /**
   * @generated from enum value: UZ = 860;
   */
  UZ = 860,

  /**
   * @generated from enum value: VA = 336;
   */
  VA = 336,

  /**
   * @generated from enum value: VC = 670;
   */
  VC = 670,

  /**
   * @generated from enum value: VE = 862;
   */
  VE = 862,

  /**
   * @generated from enum value: VG = 92;
   */
  VG = 92,

  /**
   * @generated from enum value: VI = 850;
   */
  VI = 850,

  /**
   * @generated from enum value: VN = 704;
   */
  VN = 704,

  /**
   * @generated from enum value: VU = 548;
   */
  VU = 548,

  /**
   * @generated from enum value: WF = 876;
   */
  WF = 876,

  /**
   * @generated from enum value: WS = 882;
   */
  WS = 882,

  /**
   * For testing
   *
   * @generated from enum value: XT = 963;
   */
  XT = 963,

  /**
   * @generated from enum value: YE = 887;
   */
  YE = 887,

  /**
   * @generated from enum value: YT = 175;
   */
  YT = 175,

  /**
   * @generated from enum value: ZA = 710;
   */
  ZA = 710,

  /**
   * @generated from enum value: ZM = 894;
   */
  ZM = 894,

  /**
   * @generated from enum value: ZW = 716;
   */
  ZW = 716,

  /**
   * Unknown
   *
   * @generated from enum value: ZZ = 999;
   */
  ZZ = 999,
}

/**
 * Describes the enum squareup.common.countries.Country.
 */
export const CountrySchema: GenEnum<Country> = /*@__PURE__*/
  enumDesc(file_squareup_common_countries, 0);

